module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "container"
    }
  }, [_c('header', {
    staticClass: "navbar navbar-default navbar-static-top",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('h1', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.$t("app.title"))), _c('img', {
    attrs: {
      "src": "/network/static/img/sun.png",
      "alt": "FEN",
      "title": "FEN",
      "height": "40"
    }
  })])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "id": "column-left"
    }
  }, [_c('ul', {
    attrs: {
      "id": "menu"
    }
  }, [(_vm.$user.familyUser) ? _vm._l((_vm.$config.basicLists.menuItems), function(menuItem, key) {
    return _c('li', {
      attrs: {
        "id": key
      }
    }, [_c('router-link', {
      staticClass: "text-nowrap",
      attrs: {
        "to": menuItem.link,
        "data-toggle": "tooltip",
        "data-placement": "right",
        "title": menuItem.title
      }
    }, [_c('i', {
      staticClass: "fa fa-fw",
      class: menuItem.icon
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(menuItem.title))])])], 1)
  }) : _vm._e(), _vm._v(" "), (_vm.$user.role === 'admin' || _vm.$user.role === 'moderator') ? _c('li', {
    attrs: {
      "id": "admin"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/moderate/registration/list",
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Регистрации"
    }
  }, [_c('i', {
    staticClass: "fa fa-users fa-fw"
  }), _c('span', [_vm._v("Регистрации")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/moderate/category/list",
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Категории"
    }
  }, [_c('i', {
    staticClass: "fa fa-tree fa-fw"
  }), _c('span', [_vm._v("Категории")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/moderate/section/list",
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Секции"
    }
  }, [_c('i', {
    staticClass: "fa fa-list fa-fw"
  }), _c('span', [_vm._v("Секции")])])], 1)])]) : _vm._e(), _vm._v(" "), _c('li', {
    attrs: {
      "id": "exit"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/logout",
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Изход"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out fa-fw"
  }), _c('span', [_vm._v("Изход")])])], 1)], 2)]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "parent",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "right",
      "title": "Администрация"
    }
  }, [_c('i', {
    staticClass: "fa fa-wrench fa-fw"
  }), _vm._v(" "), _c('span', [_vm._v("Администрация")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f4b03e1!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/Dash.vue
// module id = 645
// module chunks = 1